import { ActionType, createAction } from 'typesafe-actions'

export const LocationActions = {
  setLocation: createAction('LOCATION_CHANGE')<{
    currentLocationPath: string
  }>()
}

export type LocationActions = ActionType<typeof LocationActions>
